var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-ccfwawa",class:'step_'+_vm.step},[_c('div',{staticClass:"m-ccfwawa--pre"}),_c('div',{staticClass:"m-ccfwawa--img absolute"}),_c('Dialog',{attrs:{"type":_vm.type,"content":_vm.contents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }